<template>
  <div class="navbar">
    <div class="btn-close" @click="goBack"></div>
    <div class="nav-item-list">
      <template v-for="(link, index) in routeGroup.links"
        ><router-link
          v-if="!link.hidden"
          :key="index"
          class="nav-item"
          :class="[curNavItem === link.key && 'active']"
          :to="link.to"
          @click.native="clickRouter"
        >
          <i class="icon" :class="link.icon"></i>{{ link.name }}
        </router-link></template
      >

      <!-- <router-link class="nav-item" :class="[curNavItem === 'live-stream' && 'active']" to="/">
        <i class="icon icon-live-stream"></i>{{getDict(1)}}
      </router-link>
      <router-link class="nav-item" :class="[curNavItem === 'video' && 'active']" to="/video-list">
        <i class="icon icon-video"></i>{{getDict(2)}}
      </router-link>
      <router-link class="nav-item" :class="[curNavItem === 'news' && 'active']" to="/news">
        <i class="icon icon-news"></i>{{getDict(3)}}
      </router-link>
      <router-link class="nav-item" :class="[curNavItem === 'person' && 'active']" to="/personal-center">
        <i class="icon icon-person"></i>{{getDict(4)}}
      </router-link> -->
    </div>

    <!-- url跳转 -->
    <!-- <a 
      v-for="(linkMore,index) in routeGroup.more"
      :key="index"
      class="nav-item-fixed" 
      :to="linkMore.to"
      @click="goTo(linkMore,true)"
    >
      <i class="icon" :class="linkMore.icon"></i>{{curNavItem !== linkMore.key?linkMore.name:getDict(23)}}<i class="icon icon-more-down" :class="{active:curNavItem === linkMore.key}"></i>
    </a> -->

    <!-- 弹窗 -->
    <a
      v-for="(linkMore, index) in routeGroup.more"
      :key="index"
      class="nav-item-fixed"
      @click="goTo(linkMore, true)"
    >
      <i class="icon" :class="linkMore.icon"></i
      >{{ curNavItem !== linkMore.key ? linkMore.name : getDict(23)
      }}<i
        class="icon icon-more-down"
        :class="{ active: curNavItem === linkMore.key }"
      ></i>
    </a>
  </div>
</template>

<script>
import { getDict, getQuery, bus } from "../common";

export default {
  props: ["routeGroupKey"],
  name: "navbar",
  data() {
    return {
      routes: [
        {
          key: "index",
          links: [
            {
              name: this.getDict(1),
              key: "live-stream",
              icon: "icon-live-stream",
              to: "/",
            },
            {
              name: this.getDict(2),
              key: "video",
              icon: "icon-video",
              to: "/video-list",
            },
            // {
            //   name:this.getDict(3),
            //   key:'news',
            //   icon:'icon-news',
            //   to:'/news'
            // },
            /* {
              name: this.getDict(4),
              key: "person",
              icon: "icon-person",
              to: "/personal-center",
            }, */
            {
              name: this.getDict(300),
              key: "gamble",
              icon: "icon-nav-gamble",
              to: "/gamble",
              // hidden: !getQuery('show_gamble'),
            },
            // {
            //   name: 'debug',
            //   key: 'debug',
            //   icon: 'icon-person',
            //   to: '/demo-for-native'
            // }
          ],
          more: [
            {
              name: getDict(5),
              key: "feedback",
              icon: "icon-feedback",
              to: "/feedback",
              todo() {
                // if('feedback' == this.curNavItem){
                //   this.$router.back();
                //   return;
                // }else{
                //   this.$router.push('/feedback');
                // }

                if ("feedback" != this.curNavItem) {
                  this.$emit("popFeedBack");
                  this.myCurNavItem = "feedback";
                  bus.$once("feedBackClosed", () => {
                    this.myCurNavItem = null;
                  });
                  return;
                } else {
                  this.$emit("closeFeedBack");
                  bus.$emit("feedBackClosed");
                  this.myCurNavItem = null;
                  return;
                }
              },
            },
          ],
        },
        {
          goBack: () => {
            this.$router.replace("/");
          },
          key: "feedback",
          links: [
            {
              name: getDict(21),
              key: "feedback",
              icon: "icon-feedback",
              to: "/feedback",
            },
          ],
          more: [],
        },
      ],
      myCurNavItem: null,
    };
  },
  computed: {
    curNavItem() {
      if (!!this.myCurNavItem) {
        return this.myCurNavItem;
      }
      let cur = "";
      for (let node of this.routeGroup.links) {
        if (node.to == this.$route.path) {
          return node.key;
        }
      }
      let map = {
        "live-stream": {
          path: ["", /^\/tornament\//, /^\/liveBroadcast\//],
        },
        video: {
          path: ["/video-list", /^\/video\//],
        },
        news: {
          path: ["/news"],
        },
        person: {
          path: ["/personal-center"],
        },
        gamble: {
          path: ["/gamble"],
        },
        feedback: {
          path: [/^\/feedback/],
        },
      };
      for (let key in map) {
        let list = map[key].path;
        for (let path of list) {
          if (typeof path == "string") {
            if (path == this.$route.path) {
              cur = key;
              break;
            }
          } else if (typeof path.test == "function") {
            if (path.test(this.$route.path)) {
              cur = key;
              break;
            }
          }
        }
      }
      return cur;
    },
    routeGroup() {
      let key = this.routeGroupKey || "index";
      console.log(key);
      for (let node of this.routes) {
        if (node.key == key) {
          return node;
        }
      }
      return this.routes[0];
    },
  },
  methods: {
    getDict,
    clickRouter() {
      this.$emit("closeFeedBack");
      this.myCurNavItem = null;
    },
    goBack() {
      if (this.routeGroup.goBack) {
        this.routeGroup.goBack();
      }
    },
    goTo(route, back = false) {
      if (route.todo) {
        route.todo.call(this);
        return;
      }
      this.$router.push(route.to);
    },
    ctrlPop() {},
  },
  created() {
    console.log(this);
  },
};
</script>

<style scoped lang="scss">
.navbar {
  display: flex;
  height: 0.84rem;
  background: url(../assets/nav-bg.png) no-repeat center center;
  background-size: 100% 100%;
  padding-left: 1.39rem;
  position: relative;
}
.logo {
  background: url(../assets/nav-bg-right.png) no-repeat center center;
  background-size: 100% 100%;
  width: 5.56rem;
  height: 0.84rem;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 0;
}
.btn-close {
  width: 1.39rem;
  height: 0.92rem;
  background: url(../assets/btn-nav-back.png) no-repeat center center;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
}
.nav-item-list {
  display: flex;
  flex: 1;
}
.nav-item {
  font-size: 0.24rem;
  color: #ffc44f;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 1.86rem;
  height: 0.84rem;
  padding: 0 0.29rem;
  margin-left: -0.29rem;
  .icon {
    display: inline-block;
  }
  &.active {
    background: url(../assets/nav-hover-item.png) no-repeat center center;
    background-size: 100%;
    color: #232324;
    font-weight: 600;
  }
}
.nav-item-fixed {
  /*min-width: 1.32rem;*/
  height: 0.84rem;
  padding-right: 0.36rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.2rem;
  color: #ffc44f;
  .icon-more-down {
    margin: 0.04rem 0 0 0.08rem;

    &.active {
      transform: scaleY(-1);
    }
  }
}
</style>
